import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-rates-dashboard',
  templateUrl: './rates-dashboard.component.html',
  styleUrls: ['./rates-dashboard.component.scss']
})
export class RatesDashboardComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  buttonClicked(url: string) {
    this.router.navigateByUrl(url);
  }

}
